import AxiosClient from "../AxiosClient";

export const postCsvImportOrderApi = (params) => {
  const url = "/api/csvImportOrder/importOrder";
  return AxiosClient.post(url, params);
};

export const postAddOrderApi = (params) => {
  const url = "/api/csvImportOrder/addOrder";
  return AxiosClient.post(url, params);
};


